import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import MapMark from './MapMark.png';


const errorStyles = {
  width: '100%',
  background: '#f0f0f0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

class ErrorGeolocation extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }
  render() {
    if (this.state.errorInfo) {
      return (
        <div style={{...errorStyles, height: this.props.height}}>
          Тут должна была быть карта.
        </div>
      )
    }
    return this.props.children;
  }
}
ErrorGeolocation.propTypes = {
  height: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
}

const defaultMapIconFn = () => {};
export default class Geolocation extends Component {
  constructor() {
    super();
    this.state = {
      mapIconLayout: defaultMapIconFn,
      error: false,
    }
  }
  
  // https://github.com/gribnoysup/react-yandex-maps/issues/11
  handleYMapsApiAvaliable = (ymaps) => {
    this.setState({ mapIconLayout: this.createMapIconLayout(ymaps) });
  }

  createMapIconLayout = (ymaps) => {
    const MapIconLayout = ymaps.templateLayoutFactory.createClass(
      `<div style="
        width: 100px;
        max-height: 30px;
        overflow: hidden;
        min-height: 15px;
        color: #FFFFFF;
        font-weight: bold;
        background-color: #111111;
        border-radius: 3px;">$[properties.iconContent]</div>`
    );
    
    return MapIconLayout;
  }

  onYMapsError = (error) => {
    this.setState({ error });
    this.props.onError(error);
  }

  render() {
    const elementHeight = this.props.expanded ? '460px' : '115px';
    if (this.state.error) {
      return null;
    }
    return (
      <ErrorGeolocation height={elementHeight} error={this.state.error}>
        <YMaps>
          <div className='map'>
            <Map
              onLoad={(ymaps) => this.handleYMapsApiAvaliable(ymaps)}
              onError={(error) => this.onYMapsError(error)}
              modules={['templateLayoutFactory']}
              state={{
                center: this.props.geolocation,
                zoom: 10
              }}
              width='100%'
              height={elementHeight}
            >
              <Placemark
                geometry={this.props.geolocation}
                properties={{
                  hintContent: this.props.hintMessage,
                  balloonContent: '',
                  iconContent: this.props.hintMessage,
                }}
                options={{
                  iconLayout: 'default#imageWithContent',
                  iconImageHref: MapMark,
                  iconImageSize: [30, 42],
                  iconImageOffset: [-3, -42],
                  iconContentOffset: [-35, 45],
                  iconContentLayout: this.state.mapIconLayout,
                }}
                modules={['geoObject.addon.balloon', 'geoObject.addon.hint', 'layout.ImageWithContent']}
              />
            </Map>
            <div className="map-overlay"></div>
          </div>
        </YMaps>
      </ErrorGeolocation>
    )
  }
};

Geolocation.propTypes = {
  expanded: PropTypes.bool.isRequired,
  hintMessage: PropTypes.string.isRequired,
  geolocation: PropTypes.arrayOf(PropTypes.number).isRequired,
  onError: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Event/Geolocation.js